import { SMART_CRAFT_CLIENT } from 'config/constants/endpoints'
import request, { gql } from 'graphql-request'

interface TokenResponse {
  id: string
  decimals: number
}

interface UserSmartCraftClaimRewardResponse {
  amount: number
  token: TokenResponse
}

interface UserSmartCraftDataResponse {
  smartCraftClaimRewards: UserSmartCraftClaimRewardResponse[]
}

export const getUserSmartCraftData = async (
  address: string,
): Promise<{ data?: UserSmartCraftClaimRewardResponse[]; error: boolean }> => {
  try {
    const query = gql`
      query smartCraftClaimRewards($address: Bytes!) {
        smartCraftClaimRewards(where: { user: $address }) {
          amount
          token {
            id
            decimals
          }
        }
      }
    `
    const { smartCraftClaimRewards } = await request<UserSmartCraftDataResponse>(SMART_CRAFT_CLIENT, query, {
      address: address.toLowerCase(),
    })
    if (smartCraftClaimRewards) {
      return { data: smartCraftClaimRewards, error: false }
    }
    return { error: true }
  } catch (error) {
    console.error('Failed to fetch user smart craft data', error)
    return { error: true }
  }
}
